<template>
  <section class="bullets-section">
    <div class="container-info">
      <div class="container-title">
        <h2>Todo lo que debe saber</h2>
      </div>
      <p>
        Ahorro económico, aporte ambiental, rendimiento fenomenal. <br />
        Conozca la oferta y los beneficios de los carros eléctricos
      </p>
      <ul class="bullets-azules">
        <li>
          <a href="#Beneficios">Beneficios económicos del carro eléctrico</a>
        </li>
        <li><a href="#Autonomia">Autonomía</a></li>
        <li><a href="#Estaciones">Estaciones de carga</a></li>
        <li><a href="#Bateria">Batería</a></li>
        <li><a href="#Autos">Cantidad de autos eléctricos</a></li>
        <li><a href="#Impacto">Impacto Ambiental</a></li>
        <li>
          <a href="#ASOMOVE">
            Asociación Costarricense de Movilidad Eléctrica
          </a>
        </li>
        <li><a href="#Historia">Historia de los carros eléctricos</a></li>
      </ul>
    </div>

    <div class="container-cards">
      <div id="Beneficios" class="content-header">
        <div class="container">
          <h3>
            Beneficios económicos <br />
            del carro eléctrico
          </h3>
        </div>
        <img src="/assets/asset-blue-car.png" />
      </div>

      <div class="container">
        <div class="container-grid">
          <div class="cardGrid-1">
            <div class="cardTitle gray-title">
              <h4>Ahorro en el costo de la energía</h4>
            </div>

            <div class="CardContent">
              En muchos casos es más barato operar un vehículo eléctrico, que
              uno que consume el combustible fósil. El monto del ahorro depende
              en el costo de la electricidad donde usted vive o trabaja, el
              precio del combustible convencional, y las horas en las que tenga
              el carro conectado con la fuente eléctrica. Sin embargo, el ahorro
              en muchos casos es del 50% o más.
            </div>
          </div>

          <div class="cardGrid-2">
            <div class="cardTitle gray-title">
              <h4>Préstamo bancario preferencia:</h4>
            </div>
            <div class="CardContent">
              Varias entidades financieras ofrecen opciones para la compra de
              autos eléctricos, con condiciones preferenciales.
            </div>
          </div>

          <div class="cardGrid-3">
            <div class="cardTitle gray-title">
              <h4>Seguro preferencial:</h4>
            </div>
            <div class="CardContent">
              Varias aseguradoras ofrecen un descuento en la prima para el
              vehículo eléctrico.
            </div>
          </div>

          <div class="cardGrid-4">
            <div class="cardTitle blue-title">
              <h4>Mantenimiento barato</h4>
            </div>
            <div class="CardContent">
              El carro eléctrico genera un ahorro en varias áreas de
              mantenimiento. La batería y los componentes electrónicos no
              requieren revisión o repuestos. El carro no ocupa aceite. Hay
              pocas partes móviles que se descomponen no hay cilindros,
              pistones, válvulas, cigueñales, colectores de escape, muflas y
              mucho más. El carro eléctrico no usa aceites, bujías, u otros
              insumos que se desgastan. El mantenimiento se limita a unas pocas
              piezas como compensadores, luces y limpiapara-brisas. Mientras el
              desgaste de los frenos se reduce por el frenado regenerativo, un
              proceso que transfiere la energía de las ruedas a la batería.
            </div>
          </div>

          <div class="cardGrid-5">
            <div class="cardTitle blue-title">
              <h4>Marchamo reducido</h4>
            </div>
            <div class="containerGrid-5">
              <div class="CardContent">
                Hay exoneración del impuesto a la propiedad la parte más
                importante del marchamo por cinco años para el vehículo
                eléctrico nuevo, en la siguiente forma por año
                <br />
                <br />
                Para obtener la reducción del marchamo, se debe inscribir el
                carro en el sistema Exonet del Ministerio de Hacienda para
                efectos del primer año, luego el programa automáticamente
                aplicará el descuento relevante en los siguientes años.
              </div>
              <div class="CardContent-Extra">
                <p class="ano-porcentaje">Datos en porcentaje de exoneración</p>
                <img class="grafico-anos" src="/assets/grafico-anos.jpg" />
              </div>
            </div>
          </div>
          <div class="cardGrid-6">
            <div class="cardTitle blue-title">
              <h4>Beneficios en restricción y parqueos</h4>
            </div>
            <div class="CardContent">
              La restricción vehicular no se aplica a un carro eléctrico.
              Además, se puede usar los parqueos azules preferenciales y estar
              exonerado del pago de parquímetros en varias municipalidades.
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "BulletsComponent",
  data() {
    return {
      title: "Título"
    };
  }
};
</script>

<style scoped lang="scss">
.cardGrid-1,
.cardGrid-2,
.cardGrid-3,
.cardGrid-4,
.cardGrid-5,
.cardGrid-6 {
  background: #dadee1;
  font-size: 0.9em;
  .CardContent {
    padding: 1em;
  }
}

h2 {
  font-size: 3rem;
  margin-bottom: 1rem;
  font-weight: 600;
}

img.grafico-anos {
  max-width: none;
  width: calc(100% + 2.5rem);
  margin-left: -1.35rem;
  margin-top: 1rem;
}

.container-info {
  max-width: 680px;
  width: 100%;
  margin: 4em auto;

  p {
    font-weight: 500;
  }
}
.bullets-azules {
  padding: 2em;
  line-height: 1.2;
  font-weight: 600;
  font-size: 1.2rem;

  li {
    position: relative;
    margin-bottom: 5px;

    &:before {
      position: absolute;
      background: #2c8cdd;
      width: 1em;
      height: 1rem;
      content: "";
      margin-left: -2em;
      margin-top: 0.1rem;
    }

    a {
      color: #4a4a4a;
    }
    a:hover {
      text-decoration: none;
      opacity: 0.8;
    }
  }
}
.content-header {
  position: relative;
  background: #2c8cdd;
  padding: 2em 2em 6em;

  h3 {
    max-width: 680px;
    width: 100%;
    margin: auto;
    font-size: 2rem;
    color: #fff;
  }

  img {
    position: absolute;
    bottom: 0;
    right: 0;
    height: auto;
    width: 40%;
  }
}

/*GRID*/
.container-grid {
  max-width: 100%;
  padding: 1em;
  margin: auto;
  margin-top: -5rem;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 0.6fr 0.8fr 1.2fr;
  gap: 30px 30px;
  grid-template-areas:
    "cardGrid-1 cardGrid-2 cardGrid-3"
    "cardGrid-1 cardGrid-5 cardGrid-5"
    "cardGrid-4 cardGrid-5 cardGrid-5"
    "cardGrid-4 cardGrid-6 cardGrid-6"
    ". . .";
  .cardTitle {
    font-size: 1.2rem;
    font-weight: 700;
    padding: 1em 1.5em;
    height: 4rem;
    position: relative;
    display: flex;
    align-items: center;

    &.gray-title {
      background: #ffffff;
    }

    &.blue-title {
      background: #2c8cdd;
      h4 {
        color: #fff !important;
      }
    }
  }

  .ano-porcentaje {
    font-weight: 700;
    line-height: 1;
  }

  .table-DataPorcentajes th {
    padding-right: 15px;
  }
  .table-DataPorcentajes td {
    line-height: 1;
    font-weight: 700;
  }

  .containerGrid-5 {
    display: flex;
    .CardContent {
      width: 60%;
      background: #dadee1;
      font-weight: 500;
      padding: 1.5em 1.5em;
    }
    .CardContent-Extra {
      width: 40%;
      background: #e9eded;
      font-weight: 500;
      padding: 1em 1.5em;
    }
  }
  .cardGrid-2 {
    grid-area: cardGrid-2;
  }
  .cardGrid-3 {
    grid-area: cardGrid-3;
    z-index: 2;
  }
  .cardGrid-1 {
    grid-area: cardGrid-1;
  }
  .cardGrid-5 {
    grid-area: cardGrid-5;
  }
  .cardGrid-4 {
    grid-area: cardGrid-4;
  }
  .cardGrid-6 {
    grid-area: cardGrid-6;
  }
}
@media only screen and (max-width: 838px) {
  .container-grid {
    max-width: 100%;
    padding: 0;
    margin-top: -4rem;
    grid-template-columns: 1.4fr 0.8fr 0.8fr;
    grid-template-rows: 1fr 1fr 1fr;
    gap: 15px 15px;
    grid-template-areas:
      "cardGrid-1 cardGrid-2 cardGrid-3"
      "cardGrid-5 cardGrid-5 cardGrid-5"
      "cardGrid-4 cardGrid-4 cardGrid-6";
  }
  .cardTitle h4[data-v-74f07fff] {
    font-size: 1rem;
  }
}
@media only screen and (max-width: 767px) {
  .container-info {
    max-width: 100%;
    width: 100%;
    margin: 0;
    padding: 4em 2em;
  }
  .content-header {
    padding: 2rem 0 6em;
  }
  .container-grid {
    min-height: 594.562px;
    display: grid;
    grid-template-columns: 1fr;
    margin-top: -4rem;
    grid-gap: 1.5rem;
    place-items: center;
    align-items: flex-start;
    place-content: center;
    grid-template-rows: auto;
    grid-template-areas: initial !important;

    .cardGrid-2,
    .cardGrid-3 {
      .cardTitle {
        background: #2c8bdd;
        h4 {
          color: #fff;
        }
      }
    }
    .containerGrid-5 {
      flex-direction: column;
      .CardContent,
      .CardContent-Extra {
        width: 100%;
      }
    }
  }

  .cardGrid-2,
  .cardGrid-3,
  .cardGrid-1,
  .cardGrid-5,
  .cardGrid-4,
  .cardGrid-6 {
    grid-area: auto !important;
    width: 100%;
    .CardContent {
      padding: 1em;
    }
  }
}

@media only screen and (max-width: 460px) {
  .content-header {
    img {
      display: none;
    }
  }
}
</style>
